const doc = [({"zh_tw":({"buttonBookingCamp":({"cancelBookingPlan":"取消此預訂", "cancelBookingRoom":"取消該批次的預訂"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;